import { jsx as _jsx } from "react/jsx-runtime";
import { palette } from "../../Theme";
import { TruffleSvgGradientId } from "../../Utils";
const gradientStops = palette.brand.gradientMagentaBlue
    .split(",")
    .map((stop) => {
    const [color, offset] = stop.trim().split(" ");
    return { color, offset };
});
export const TruffleGradientDefinitions = () => (_jsx("svg", { width: "0", height: "0", style: { position: "absolute" }, children: _jsx("defs", { children: _jsx("linearGradient", { id: TruffleSvgGradientId, x1: "0", y1: "0", x2: "1", y2: "1", children: gradientStops.map((stop, index) => (_jsx("stop", { offset: stop.offset, stopColor: stop.color }, index))) }) }) }));
//# sourceMappingURL=TruffleGradientDefinitions.js.map